import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/payroll-core/_layout/config/')({
  component: () => null
});